module.exports = __webpack_public_path__ + "static/sertifika-izmir-enternasyonal-fuari-1936-caf60ab424ffc26e8af7e6bb609e2433.jpg";